import { PublicMobileBroadbandSubscriptions } from '../../../components/PublicMobileBroadbandSubscriptions/PublicMobileBroadbandSubscriptions.js';

export const AnonymousMobileBroadbandPath = () => {
  return <PublicMobileBroadbandSubscriptions />;
};
